<div class="value-cell">
	<ng-container *ngIf="isSpecialCol">
		<input disabled value="{{specialValue}}">
	</ng-container>
	<ng-container *ngIf="!isSpecialCol&&(!domainsByColumn[column.prop]||domainsByColumn[column.prop].type!=='list')">
		<input name="cellValueInput"
			[placeholder]="inputPlaceholder"
			[disabled]="isEditDisabled"
			type="{{colType==='date' ? 'date' : 'text'}}"
			[ngClass]="cssClass"
			pattern="{{domainsByColumn[column.prop] ? domainsByColumn[column.prop].pattern : ''}}"
			appValidateRange="{{domainsByColumn[column.prop] ? domainsByColumn[column.prop].range : null}}"
			[(ngModel)]="cellValue" 
			(ngModelChange)="onInputVal()" 
			(blur)="onBlur()" 
			(keyup.enter)="onEnter()">
			<!-- [appInputUppercase]="column.isUppercase" -->

		<!-- <div *ngIf="colType==='date'">
		</div> -->
	</ng-container>
	<ng-container *ngIf="!isSpecialCol&&(domainsByColumn[column.prop]&&domainsByColumn[column.prop].type==='list')">
		<select *ngIf="stateOrCountyCols.indexOf(standardColName)===-1"
			name="cellValueSelect" 
			[disabled]="isEditDisabled"
			[(ngModel)]="cellValue" 
			(ngModelChange)="onSelectVal()">
			<ng-container *ngIf="cellValue && domainsByColumn[column.prop].list?.indexOf(cellValue) < 0">
				<option disabled>{{cellValue}}</option>
			</ng-container>
			<option *ngFor="let val of domainsByColumn[column.prop].list" [ngValue]="val">{{val}}</option>
			<option [ngValue]="null">Null</option>
		</select>
		<select #S *ngIf="stateOrCountyCols.indexOf(standardColName)>-1"
			name="cellValueSelect" 
			[disabled]="isEditDisabled"
			[ngModel]="cellValue" 
			(ngModelChange)="onChangeStateOrCounty($event, S)">

			<option *ngFor="let val of domainsByColumn[column.prop].list" [ngValue]="val">{{val}}</option>
			
			<ng-container *ngIf="!column.neighborList">
				<option [ngValue]="neighborOption">&lt; Neighbors &gt;</option>
			</ng-container>

			<ng-container *ngIf="column.neighborList">
				<option disabled>──────────</option>
				<ng-container *ngIf="standardColName===countyColStandard || standardColName===countyLeftColStandard || standardColName===countyRightColStandard">
					<option *ngFor="let val of column.neighborList" [ngValue]="val.value">{{val.label}}</option>
				</ng-container>
				<ng-container *ngIf="standardColName===stateColStandard || standardColName===stateLeftColStandard || standardColName===stateRightColStandard">
					<option *ngFor="let val of column.neighborList" [ngValue]="val">{{val}}</option>
				</ng-container>
			</ng-container>
		</select>
	</ng-container>
</div>